import React from 'react';
import { Box, Flex } from '@mantine/core';

type SuitabilityLayoutProps = {
  header: React.ReactNode;
  body: React.ReactNode;
};

export function SuitabilityLayout({ header, body }: SuitabilityLayoutProps) {
  return (
    <Flex
      mih={0}
      bg="white"
      flex={1}
      direction="column"
      display="flex"
      style={{
        borderRadius: 24,
      }}
    >
      {header}
      <Box mih={0} flex={1}>
        {body}
      </Box>
    </Flex>
  );
}
